import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import SplitPane from "react-split-pane";
import MonacoEditor from "./MonacoEditor";
import constants from "../../../constants";
import { IconButton } from "@mui/material";
import Tooltip from "../../CommonComponents/Tooltip";
import Pane from "react-split-pane/lib/Pane";
import CustomTabPanel from "./CustomTabPanel";
import Popup from "../../CommonComponents/Popup";
import Profile from "../Home/LandingPage/Profile";
import { getDataFromStorage } from "../../../util";
import Scrollbars from "react-custom-scrollbars-2";
import CustomFileExplorer from "./CustomFileExplorer";
import AlertContext from "../../../context/AlertContext";
import { sandpackDark } from "@codesandbox/sandpack-themes";
import FullScreenSvgIcon from "../../../Svg/FullScreenSvgIcon";
import Loading from "../../Notification-Loading/Loading/Loading";
// import useUploadLargeFileToS3 from "../../../Hooks/useUploadLargeFileToS3";
import SandPackRunBtnHooks from "../../../Hooks/SandPack/SandPackRunBtnHooks";
import SandPackEditorSplitHooks from "../../../Hooks/SandPackEditorSplitHooks";
import useS3FileManagement from "../../../Hooks/useS3FileManagement";

import React, {
  useRef,
  useState,
  useEffect,
  useContext,
  useCallback,
  memo,
} from "react";

import {
  FileTabs,
  useSandpack,
  useActiveCode,
  SandpackLayout,
  SandpackThemeProvider,
} from "@codesandbox/sandpack-react";

// export function validateImageExtension(file) {
//   let allowedExtensions = ["jpg", "jpeg", "png", "gif"];
//   let extension = file.name.split(".").pop().toLowerCase();

//   return allowedExtensions.indexOf(extension) !== -1;
// }

const convertIntoSandpackFiles = (files) => {
  return files.reduce((acc, cur) => {
    acc[`/${cur.filename}`] = {
      code: cur.fileContents,
    };
    return acc;
  }, {});
};

const a11yProps = (index) => {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
};

export default memo(function SandPackEditorTools(Props) {
  const {
    handleDragFinished,
    outputWindowHeight,
    problemWindowHeight,
    setOutputWindowHeight,
    setProblemWindowHeight,
    handleProblemDragFinished,
  } = SandPackEditorSplitHooks();

  const {
    isAdmin,
    testData,
    learnerId,
    isTakeTest,
    isFullScreen,
    isCommonPopup,
    sandpackFiles,
    setIsFullScreen,
    setSandpackFiles,
    allWindowsBlurred,
    openSandpackEditor,
    setOpenRecommendedList,
    contentData,
  } = useContext(AlertContext);

  const { electronAPI } = window;
  const { sandpack } = useSandpack();
  const { updateCode } = useActiveCode();
  const { getS3ObjectsByFolder, getFileDataByfolder } = useS3FileManagement();

  const {
    refreshKey,
    previewUrl,
    refreshIframe,
    consoleMessages,
    setConsoleMessages,
    previewLoaded,
    setPreviewLoaded,
  } = SandPackRunBtnHooks();

  const preValue = useRef(0);
  const outputRef = useRef(null);
  const previewRef = useRef(null);
  const getSandpackFilesCalled = useRef(false);

  const [value, setValue] = useState(0);
  const [filesLoaded, setFilesLoaded] = useState(false);


  const getSandpackFiles = useCallback(async () => {
    if (
      (isAdmin && Props.isqueReport) ||
      (!isAdmin &&
        Props.isAddSubmission &&
        Props.status === constants.PROGRESS_STATUS.UNLOCKED)
    ) {
      const filePath = `${process.env.REACT_APP_WEBSITE_HOST}/library/${Props.libDetails.id}`;

      // let fileData = await getS3ObjectsByFolder(filePath, "HOST");
      let fileData = await getFileDataByfolder(filePath + "/", "HOST");
      console.log("fileData", fileData);
      const files = convertIntoSandpackFiles(fileData);
      console.log("files", files);

      sandpack.addFile(files);
      updateCode(files[sandpack.activeFile]?.code);
      setFilesLoaded(true);
    } else if (Props.status !== constants.PROGRESS_STATUS.UNLOCKED) {
      const filePath = `${process.env.REACT_APP_WEBSITE_HOST}/${
        Props.libDetails.id
      }/${isAdmin ? learnerId : getDataFromStorage("learnerid")}`;

      // let fileData = await getS3ObjectsByFolder(filePath, "HOST");
      let fileData = await getFileDataByfolder(filePath + "/", "HOST");
      console.log("fileData", fileData);

      const files = convertIntoSandpackFiles(fileData);
      console.log("files", files);

      if (files) {
        sandpack.updateFile(files);
        sandpack.openFile("/index.html");
      }
      sandpack.addFile(files);
      updateCode(files[sandpack.activeFile]?.code);
      setFilesLoaded(true);
    } else {
      return;
    }
  }, [
    isAdmin,
    Props.status,
    Props.libDetails,
    Props.isqueReport,
    Props.isAddSubmission,
    learnerId,
    updateCode,
  ]);

  useEffect(() => {
    const savedSize = localStorage.getItem("splitPos");
    const savedWidthSize = localStorage.getItem("splitWidthPos");

    if (savedSize) {
      const [,] = savedSize.split(","); // Extract the height percentage value
      setOutputWindowHeight(8.4);
    }

    if (savedWidthSize) {
      const [widthPercentage] = savedWidthSize.split(",");
      const parsedWidth = parseFloat(widthPercentage.replace("%", ""));

      setProblemWindowHeight(parsedWidth);
    }

    const editorHeightdiv = document.getElementById("sandpackCodeEditor");

    if (editorHeightdiv) {
      editorHeightdiv.style.height = `90vh`;
    }
  }, [setProblemWindowHeight, setOutputWindowHeight]);

  // useEffect(() => {
  //   if (previewLoaded) {
  //     setTimeout(() => {
  //       setPreviewLoaded(false);
  //     }, 1000);
  //   }
  // }, [previewLoaded]);

  useEffect(() => {
    // Fetch the list of all windows initially

    electronAPI?.getAllWindows().then((windowList) => {
      console.log("windowList", windowList);
    });

    // Listen for window change events

    const handleWindowChange = (message) => {
      // Refresh the window list

      electronAPI?.getAllWindows().then((windowList) => {
        console.log("windowList", windowList);
      });
    };

    electronAPI?.onWindowsChanged(handleWindowChange);

    // Cleanup listener when the component unmounts

    return () => {
      electronAPI?.offWindowsChanged(handleWindowChange);
    };
  }, []);

  useEffect(() => {
    // const handleWindowsBlurred = (event, data) => {
    //   console.log("Both windows are blurred:", data.status);
    // };

    electronAPI?.onWindowsBlurred((data) => {
      console.log("Test listener:", data);

      console.log(
        "allWindowsBlurred in sandpackEditorTools",
        allWindowsBlurred.current,
      );

      allWindowsBlurred.current = data.status === "blur";

      if (!allWindowsBlurred.current) {
        Props.focusOutSec.current = 0;
      }
    });

    return () => {
      electronAPI?.removeWindowsBlurredListener();
    };
  }, []);

  useEffect(() => {
    // Capture desktop sources when the app starts

    electronAPI?.captureDesktopSources();

    // Listen for updated desktop sources from the main process

    const handleDesktopSources = (event, sources) => {
      console.log("Received Desktop Sources in React:", sources); // Log sources in React
    };

    electronAPI?.onDesktopSourcesUpdated(handleDesktopSources);

    // Cleanup listeners on component unmount

    return () => {
      electronAPI?.onDesktopSourcesUpdated(() => {});
    };
  }, []);

  useEffect(() => {
    if (!getSandpackFilesCalled.current) {
      // if (Props.libDetails.id) {
      getSandpackFiles();
      // }

      getSandpackFilesCalled.current = true;
    }
  }, [getSandpackFiles, Props.libDetails.id]);

  useEffect(() => {
    console.log("UseEffect running on sandpackFiles....");

    setSandpackFiles(sandpack.files);

    console.log("sandpackFiles from useEffect:", sandpackFiles);
  }, [sandpack, setSandpackFiles]);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data.message) {
        setConsoleMessages((prevMessages) => [
          ...prevMessages,
          event.data.message,
        ]);
      }
    };

    if (window.addEventListener) {
      window.addEventListener("message", handleMessage);
    } else {
      window.attachEvent("onmessage", handleMessage);
    }

    return () => {
      if (window.removeEventListener) {
        window.removeEventListener("message", handleMessage);
      } else {
        window.detachEvent("onmessage", handleMessage);
      }
    };
  }, [previewUrl, setConsoleMessages]);

  useEffect(() => {
    if (value === 0) {
      setConsoleMessages([]); // Reset on every tab switch to Console
    }
  }, [value, setConsoleMessages]);

  // const refreshIframe = async () => {
  //   setConsoleMessages([]);
  //   setRefreshKey((prevKey) => prevKey + 1);

  //   const learnerId = getDataFromStorage("learnerid");

  //   const s3Object = await getS3ObjectsByFolder(
  //     isAdmin && Props.isqueReport
  //       ? `${process.env.REACT_APP_WEBSITE_HOST}/library/${Props.libDetails.id}`
  //       : isAdmin
  //       ? `${process.env.REACT_APP_WEBSITE_HOST}/admin/${learnerId}`
  //       : `${process.env.REACT_APP_WEBSITE_HOST}/learner/${learnerId}`
  //   );

  //   if (Object.keys(s3Object ?? {}).length)
  //     await deleteS3Objects(
  //       Object.keys(s3Object).map((file) => ({
  //         Key:
  //           isAdmin && Props.isqueReport
  //             ? `${process.env.REACT_APP_WEBSITE_HOST}/library/${Props.libDetails.id}${file}`
  //             : isAdmin
  //             ? `${process.env.REACT_APP_WEBSITE_HOST}/admin/${learnerId}${file}`
  //             : `${process.env.REACT_APP_WEBSITE_HOST}/learner/${learnerId}${file}`,
  //       })),
  //       "deleteWebHost"
  //     );

  //   setSandpackFiles(sandpack.files);

  //   for (let file in sandpackFiles) {
  //     const isImage = validateImageExtension({ name: file });

  //     let extraParams = {};
  //     let code = sandpack.files[file].code;

  //     if (isImage) {
  //       extraParams.ContentEncoding = "base64";

  //       let base64Data = code
  //         .replace(/^data:application\/octet-stream;base64,/, "")
  //         .replace(/^data:image\/jpeg;base64,/, "")
  //         .replace(/^data:image\/jpg;base64,/, "")
  //         .replace(/^data:image\/png;base64,/, "");

  //       code = Uint8Array.from(atob(base64Data), (char) => char.charCodeAt(0));
  //     }

  //     try {
  //       await uploadFileToS3(
  //         code,
  //         isAdmin && Props.isqueReport
  //           ? `${process.env.REACT_APP_WEBSITE_HOST}/library/${Props.libDetails.id}${file}`
  //           : isAdmin
  //           ? `${process.env.REACT_APP_WEBSITE_HOST}/admin/${learnerId}${file}`
  //           : `${process.env.REACT_APP_WEBSITE_HOST}/learner/${learnerId}${file}`,
  //         file.split(".")[1],
  //         "uploadAssignment",
  //         extraParams
  //       );
  //     } catch (error) {
  //       console.error("Error uploading file to S3:", error);
  //     }
  //   }

  //   setSandpackFiles(sandpack.files);

  //   const baseURL = `https://gradiouslmsapp.s3.ap-south-1.amazonaws.com/${process.env.REACT_APP_WEBSITE_HOST}`;

  //   const previewUrl =
  //     isAdmin && Props.isqueReport
  //       ? `${baseURL}/library/${Props.libDetails.id}/index.html`
  //       : isAdmin
  //       ? `${baseURL}/admin/${learnerId}/index.html`
  //       : `${baseURL}/learner/${learnerId}/index.html`;

  //   setPreviewUrl(previewUrl);

  //   return previewUrl;
  // };

  const handleChange = (event, newValue) => {
    event.preventDefault();
    preValue.current = newValue;
    setValue(newValue);
  };

  const handleOpenInNewTab = async () => {
    await refreshIframe();

    let adminId = getDataFromStorage("learnerid");
    let pathPart = isAdmin ? "admin" : Props.libDetails.id;
    let url = `https://gradiouslmsapp.s3.ap-south-1.amazonaws.com/${process.env.REACT_APP_WEBSITE_HOST}/${pathPart}/${adminId}/index.html`;

    window.open(url, "_blank").focus();
  };

  const handleFullScreen = () => {
    if (!isFullScreen) {
      // Request full-screen mode

      if (outputRef.current.requestFullscreen) {
        outputRef.current.requestFullscreen();
      } else if (outputRef.current.mozRequestFullScreen) {
        outputRef.current.mozRequestFullScreen();
      } else if (outputRef.current.webkitRequestFullscreen) {
        outputRef.current.webkitRequestFullscreen();
      } else if (outputRef.current.msRequestFullscreen) {
        outputRef.current.msRequestFullscreen();
      }

      setIsFullScreen(true);
    } else {
      // Exit full-screen mode

      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }

      setIsFullScreen(false);
    }
  };

  return (
    <SandpackLayout>
      <SandpackThemeProvider theme={sandpackDark}>
        <span
          className="helpIcon"
          onClick={() => {
            setOpenRecommendedList(true);
          }}
        >
          <svg
            width="18"
            height="19"
            fill="none"
            viewBox="0 0 18 19"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              stroke="#F55533"
              stroke-width="1.4"
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M6.8175 7.25C6.99383 6.74875 7.34186 6.32608 7.79997 6.05685C8.25807 5.78762 8.79667 5.6892 9.32038 5.77903C9.84409 5.86886 10.3191 6.14114 10.6613 6.54765C11.0035 6.95415 11.1908 7.46864 11.19 8C11.19 9.5 8.94 10.25 8.94 10.25M9 13.25H9.0075M16.5 9.5C16.5 13.6421 13.1421 17 9 17C4.85786 17 1.5 13.6421 1.5 9.5C1.5 5.35786 4.85786 2 9 2C13.1421 2 16.5 5.35786 16.5 9.5Z"
            />
          </svg>
          <p className="helpText">Help</p>
        </span>

        <div className="sandpackEditor">
          {isCommonPopup && (
            <div className="popup-overlay">
              <Popup />
            </div>
          )}

          <SplitPane
            size={100}
            minSize={30}
            primary="first"
            split="vertical"
            className="fileExplorerDiv"
            onChange={handleProblemDragFinished}
          >
            <Pane
              minSize="20%"
              maxSize="30%"
              iniinitialSize="30%"
              className="fileExplorerpane"
              paneStyle={{ backgroundColor: "red" }}
              initialSize={`${problemWindowHeight}%`}
            >
              <Scrollbars autoHide>
                <CustomFileExplorer
                  sandpack={sandpack}
                  filesLoaded={filesLoaded}
                  sandpackFiles={sandpackFiles}
                  setFilesLoaded={setFilesLoaded}
                  isopenEditor={openSandpackEditor}
                  setSandpackFiles={setSandpackFiles}
                  setOpenSandpackEditor={Props.setOpenSandpackEditor}
                />
              </Scrollbars>
            </Pane>
            <SplitPane
              primary="second"
              split="horizontal"
              onChange={handleDragFinished}
            >
              <Pane
                minSize="2%"
                maxSize="90%"
                className="editor-pane"
                onChange={handleDragFinished}
              >
                <>
                  <FileTabs closableTabs={true} />
                  <MonacoEditor />
                  {isTakeTest &&
                    !isAdmin &&
                    Props.status !== constants.PROGRESS_STATUS.EVALUATED &&
                    contentData?.switchedcount < 10 &&
                    testData.proctored ===
                      constants.PROCTORING_MODE.TAB_CAM && (
                      <Profile
                        isTakeTest={isTakeTest}
                        questionid={testData.libid}
                        libtypeid={constants.libTypeIds.ASSIGNMENT}
                      />
                    )}
                  <div
                    className="sandpackRunSec"
                    onClick={() => {
                      refreshIframe();
                      setValue(0);
                    }}
                  >
                    <svg
                      width="20"
                      height="20"
                      fill="none"
                      viewBox="0 0 20 20"
                      id="sandpackRunIcon"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        stroke-width="2"
                        stroke="#F96343"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M4.16675 2.5L15.8334 10L4.16675 17.5V2.5Z"
                      />
                    </svg>
                    <button id="sandpackRunText">Run</button>
                  </div>
                </>
              </Pane>
              <Pane
                minSize={"5%"}
                maxSize={"95%"}
                id="outputParentWindowContainer"
                initialSize={`${outputWindowHeight}%`}
              >
                <div className="outputandpreview" ref={outputRef}>
                  <Box sx={{ bgcolor: "background.paper" }}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                      <Tabs
                        value={value}
                        onChange={handleChange}
                        indicatorColor="secondary"
                        className="outputsandpacktab"
                        aria-label="basic tabs example"
                      >
                        <Tab label="Output" {...a11yProps(0)} />
                        <Tab label="Console" {...a11yProps(1)} />
                        <Tooltip
                          placement="right-start"
                          title="Toggle FullScreen"
                          isIcon={true}
                        >
                          <div
                            className="openinnewtab"
                            onClick={handleFullScreen}
                          >
                            <IconButton>
                              <FullScreenSvgIcon stroke="white" />{" "}
                            </IconButton>
                          </div>
                        </Tooltip>
                      </Tabs>
                    </Box>
                    <CustomTabPanel value={value} index={0}>
                      {!previewLoaded ? (
                        <div
                          style={{
                            position: "relative",
                            transform: "translate(-70px,70px)",
                          }}
                        >
                          <Loading />
                        </div>
                      ) : (
                        <iframe
                          title="un"
                          width="100%"
                          height="100%"
                          // onLoad={() => setPreviewLoaded(true)}
                          ref={previewRef}
                          key={refreshKey}
                          src={previewUrl}
                          sandbox="allow-scripts allow-same-origin allow-modals allow-forms allow-pointer-lock"
                        />
                      )}
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={1}>
                      <div className="sandpackConsoleSec">
                        <button
                          title="Clear"
                          className="sandpackConsoleClearBtn"
                          onClick={() => setConsoleMessages([])}
                        >
                          Clear
                        </button>
                        {consoleMessages.map((message, index) => (
                          <div key={index}>{JSON.stringify(message)}</div>
                        ))}
                      </div>
                    </CustomTabPanel>
                  </Box>
                </div>
              </Pane>
            </SplitPane>
          </SplitPane>
        </div>
      </SandpackThemeProvider>
    </SandpackLayout>
  );
});
